import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Checkbox/sgds-checkbox-group";
import { register } from "../../utils/ce-registry";

register("sgds-checkbox-group", Component);

export default createComponent({
  react: React,
  tagName: "sgds-checkbox-group",
  elementClass: Component,
  events: {
    onSgdsChange: "sgds-change"
  }
});
